import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function LaptopIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M3.75 16.5V6.75a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v9.75m-18 0h19.5V18a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5v-1.5ZM13.5 8.25h-3"
        stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </BaseIcon>
  );
}
